import { render, staticRenderFns } from "./UpdateAdvisorCode.vue?vue&type=template&id=8d6b4446"
import script from "./UpdateAdvisorCode.vue?vue&type=script&lang=js"
export * from "./UpdateAdvisorCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports